import React, { useContext } from 'react';
import GoogleMap from '../../components/map_interaction/GoogleMap';
import PropTypes from 'prop-types';
import CloseIcon from '@mui/icons-material/Close';
import ItinerarySuggestionsContext from '../../components/itinerary/ItinerarySuggestionsContext';
const MapSection = React.forwardRef(({ placeDetails, toggleMap, isSmallScreen, showMap, readOnly, activeSection }, ref) => {
  const { suggestions } = useContext(ItinerarySuggestionsContext);
  const suggestionsToPass = activeSection === 'chatbot' ? suggestions : [];
  if (!placeDetails) return null;
  return (
    <section className={`map-wrapper ${showMap ? (isSmallScreen ? 'fullscreen' : '') : 'hidden'}`} ref={ref}>
      <GoogleMap
        location={placeDetails.location}
        suggestions={suggestionsToPass}
        toggleMap={toggleMap}
        isSmallScreen={isSmallScreen}
        showMap={showMap}
        readOnly={readOnly}
        pageName="ItineraryPage"
      />
      {isSmallScreen && showMap && (
        <div className="itinerary-map-close-button-container">
          <button className="itinerary-map-close-button" onClick={toggleMap} aria-label="Close Map" title="Close Map">
            <CloseIcon />
          </button>
        </div>
      )}
    </section>
  );
});
MapSection.propTypes = {
  placeDetails: PropTypes.object.isRequired,
  toggleMap: PropTypes.func.isRequired,
  isSmallScreen: PropTypes.bool.isRequired,
  showMap: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  activeSection: PropTypes.string.isRequired,
};
export default MapSection;
